import Family from "./family";
import Model from "./model";
import Syllabus from "./syllabus";
import Video from "./video";

export enum Difficulty {
  Beginner = "Beginner",
  Moderate = "Moderate",
  Intermediate = "Intermediate",
  Advanced = "Advanced",
}

export default interface Move extends Model {
  name: string;
  level: number;
  difficulty?: Difficulty;
  instructions?: string;
  family?: Family;
  videos?: Video[];
  syllabus?: Syllabus;
}
